import { z } from "zod";

export const sdgTargetResultSchema = z.object({
  id: z.number(),
  target_number: z.number(),
  description: z.string(),
  score: z.number().nullable(),
  evaluation_note: z.string().nullable(),
});

export type SdgTargetResult = z.infer<typeof sdgTargetResultSchema>;
